// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'wifi-off';

export const Component = () => (
  <path d='M24.522 5.927 12.26 22.594 0 5.927C3.688 3.293 7.759 2 12.26 2c4.503 0 8.574 1.293 12.262 3.927ZM1.39 6.07h.048l10.775 15.04L23.037 6.07c-3.305-2.06-6.945-3.065-10.824-3.065-3.927 0-7.52 1.006-10.823 3.065Z' />
);

export const viewBox = '0 0 25 25';
